import Vue from 'vue'
import Meta from 'vue-meta'
import Router from 'vue-router'
import { sync } from 'vuex-router-sync'
import store from '@/store/'
import routes from './routes'
// import after from '@/middleware/after'
import * as keys from '@/router/router-keys'
// init vue-meta, vue-router
Vue.use(Meta)
Vue.use(Router)

// create router
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes,
})

// add router to store
sync(store, router)

router.afterEach(() => {
  if (store.getters['user/global_message']) {
    store.commit('user/UNSET_GLOBAL_MESSAGE')
  }
})

// global guards
router.beforeEach(async (to, from, next) => {
  // console.log('router/beforeEach | from', from)
  // console.log('router/beforeEach | to', to)
  store.dispatch('CANCEL_PENDING_REQUESTS')
  // init store
  if (!store.getters.is_init) {
    await store.dispatch('INIT_STORE')
  }

  var lastRoute = sessionStorage.getItem(keys.LS_ROUTE_KEY)
  var isExpired = sessionStorage.getItem(keys.LS_ROUTE_EXPIRED_SESSION)

  // Check if should redirect
  if (lastRoute !== '' && isExpired !== '') {
    lastRoute = JSON.parse(lastRoute)
    isExpired = JSON.parse(isExpired)

    const lastUserId = JSON.parse(sessionStorage.getItem(keys.LAST_USER))

    const shouldRedirect = Boolean(to.name === 'dashboard' && from.name === 'login' && isExpired && lastUserId === store.getters['user/id'])

    // Redirect
    if (shouldRedirect) {
      // Reset isExpiredSession
      sessionStorage.setItem(keys.LS_ROUTE_EXPIRED_SESSION, JSON.stringify(false))
      sessionStorage.setItem(keys.LS_ROUTE_KEY, '')
      const route = { name: lastRoute.name }

      // Redirect with params and query
      if (typeof lastRoute.params === 'object') Object.assign(route, { params: lastRoute.params })
      if (typeof lastRoute.query === 'object') Object.assign(route, { query: lastRoute.query })

      return next(route)
    }
  }

  // console.log({ lastRouteName: lastRouteName, shouldRedirect: shouldRedirect })

  // apply middleware
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware]

    const context = {
      from,
      next,
      router,
      to,
    }
    const nextMiddleware = nextFactory(context, middleware, 1)

    return middleware[0]({ ...context, next: nextMiddleware })
  }
  return next()
})

// router.afterEach(after)

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index]
  // If no subsequent Middleware exists,
  // the default `next()` callback is returned.
  if (!subsequentMiddleware) return context.next

  return () => {
    // Run the default Vue Router `next()` callback first.
    // context.next(...parameters)
    // Than run the subsequent Middleware with a new
    // `nextMiddleware()` callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1)
    subsequentMiddleware({ ...context, next: nextMiddleware })
  }
}

export default router
